import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import TagsInput from "react-tagsinput";
import styled from "styled-components";
import Common from "../based/Common";
import { IMAGE_TYPE, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import DragAndDropIndex from "../based/DragAndDropIndex";
import { SwichToogle } from "../based/inputs/SwitchToogle";
import LoadingR from "../based/LoadingR";
import { Notify } from "../based/Notify";
import Request from "../based/Request";
import ArtworkServices from "../based/services/ArtworkServices";
import PartnerServices from "../based/services/PartnerServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import CheckedOrange from "./assets/CheckedOrange.svg";
import EyeOff from "./assets/EyeOff.svg";
import Delete from "./assets/Delete.svg";
import { RequestDomain } from "../based/RequestDomain";

function EditCustomize(props) {
    const { designId } = props.match.params;
    const history = useHistory();
    const [tagTrending, setTagTrending] = useState([]);
    const [partnerDesign, setPartnerDesign] = useState({});
    const [listPts, setListPts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [revenue, setRevenue] = useState({});

    useEffect(() => {
        getTagTrending();
    }, []);

    useEffect(() => {
        if (designId) {
            getPartnerDesign(designId);
        }
    }, [designId]);

    useEffect(() => {
        if (partnerDesign && partnerDesign.id > 0) getListPhotoshop();
    }, [partnerDesign && partnerDesign.id]);

    async function getTagTrending() {
        let [err, data] = await ArtworkServices.GetTagTrending();
        if (!err && data && data.length > 0) setTagTrending(data);
        else setTagTrending([]);
    }

    const getPartnerDesign = async (designId) => {
        const [err, data] = await PartnerServices.GetPartnerDesignAsync(designId);
        if (!err && data) {
            setPartnerDesign(data);
        } else {
            setPartnerDesign({});
        }
    };

    const getListPhotoshop = async () => {
        const [err, data] = await PartnerServices.GetPushingPhotoshopFiles({ colorCode: partnerDesign.colorValue });
        if (!err && data) {
            setListPts(data);

            //kiểm tra nếu design không có pts thì tự check cái đầu
            if (partnerDesign && partnerDesign.id > 0 && data.length > 0) {
                let ptsUrl = partnerDesign.photoshopUrl;
                let any = data.some((x) => x.fileUrl == ptsUrl);
                if (!any) {
                    setPartnerDesign({ ...partnerDesign, photoshopUrl: data[0].fileUrl });
                }
            }
        } else {
            setListPts([]);
        }
    };

    const savePartnerDesign = async (model) => {
        setLoading(true);
        const [err, data] = await PartnerServices.CreateUpdatePartnerDesign(model);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật thiết kế thành công");
        } else {
            Notify(NOTIFY.ERROR, "Thất bại", "Cập nhật thiết kế thất bại");
        }
        setLoading(false);
    };

    const handleImageChange = (e) => {
        e.preventDefault();
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let file = e.target.files[0];
            if (file) {
                reader.onloadend = () => {
                    Request.UploadImage(file, 64)
                        .then((res) => {
                            if (res && res.data) {
                                return resolve(res.data.imageUrl);
                            } else {
                                return reject();
                            }
                        })
                        .catch((err) => {});
                };

                reader.readAsDataURL(file);
            }
        });
    };

    const handleDisabled = async (imageId, isDisabled, index) => {
        //disable ảnh
        const [err, data] = await PartnerServices.DisableImage(imageId, isDisabled);

        //config data
        let pd = { ...partnerDesign };
        let pc = pd.partnerCosts;
        let p = pc[index];
        let img = p.partnerDesignProductImages.find((x) => x.id == imageId);
        if (img) img.isDisabled = isDisabled;
        setPartnerDesign(pd);
    };

    const handleDelete = async (imageId, index) => {
        ConfirmDialog("Xác nhận xóa?", "Bạn có chắc chắn muốn xóa ảnh này không?", () => {
            return new Promise(async (resolve, reject) => {
                //xóa ảnh
                const [err, data] = await PartnerServices.RemoveImage(imageId);

                //config data
                let pd = { ...partnerDesign };
                let pc = pd.partnerCosts;
                let p = pc[index];
                p.partnerDesignProductImages = p.partnerDesignProductImages.filter((x) => x.id != imageId);
                setPartnerDesign(pd);
                resolve({ title: "Thành công", msg: "Xóa ảnh thành công." });
            });
        });
    };

    const productImageUrl = useMemo(() => {
        let imageUrl = "";
        if (partnerDesign) {
            if (partnerDesign.partnerDesignExtends && partnerDesign.partnerDesignExtends.length > 0) {
                imageUrl = partnerDesign.partnerDesignExtends[0].productImageUrl;
            }

            //kiểm tra nếu có partner design đang set mặc định
            if (partnerDesign.partnerCosts && partnerDesign.partnerCosts.length > 0) {
                const defaultItem = partnerDesign.partnerCosts.find((x) => x.isDefault);
                if (defaultItem) {
                    let lstImage = defaultItem.partnerDesignProductImages || [];
                    if (lstImage.length > 0) {
                        imageUrl = lstImage[0].productImageUrl;
                    }
                }
            }
        }

        return imageUrl;
    }, [partnerDesign]);

    if (!partnerDesign) return null;
    return (
        <React.Fragment>
            <Breadcum menu={["Trang chủ", "Quản lý thiết kế", "Chi tiết thiết kế"]} title="Thông tin sản phẩm" />
            <LoadingR isShow={loading} />
            <Wrapper>
                <section className="design-left">
                    <div className="design-left-top">
                        <h6>Thiết kế</h6>
                        <div className="design-info">
                            <div className="list-image">
                                <img src={productImageUrl} alt="" />
                            </div>
                            <div className="info-section">
                                <div className="info-area">
                                    <div className="info-line">
                                        <label htmlFor="">Dòng sản phẩm</label>
                                        <span>{partnerDesign.productName}</span>
                                    </div>
                                    <div className="info-line">
                                        <label htmlFor="">Màu</label>
                                        <span>{partnerDesign.colorName}</span>
                                    </div>
                                </div>
                                <div className="edit-button">
                                    <button
                                        className="btn btn-orange"
                                        onClick={(e) => {
                                            window.open(`${RequestDomain.HomeUrl()}/print-editor/${partnerDesign.id}`, "_blank");
                                        }}
                                    >
                                        Chỉnh sửa thiết kế
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="design-left-bottom">
                        <div className="design-side">
                            <label htmlFor="">Mặt hiển thị</label>
                            <div className="radio-box">
                                <input
                                    type="radio"
                                    checked={partnerDesign.artworkType == 1}
                                    onChange={(e) => {
                                        setPartnerDesign({ ...partnerDesign, artworkType: 1 });
                                    }}
                                    name="artworkType_1"
                                    id="artworkType_1"
                                />
                                <label htmlFor="artworkType_1">Mặt trước</label>
                            </div>
                            <div className="radio-box">
                                <input
                                    type="radio"
                                    checked={partnerDesign.artworkType == 2}
                                    onChange={(e) => {
                                        setPartnerDesign({ ...partnerDesign, artworkType: 2 });
                                    }}
                                    name="artworkType_2"
                                    id="artworkType_2"
                                />
                                <label htmlFor="artworkType_2">Mặt sau</label>
                            </div>
                        </div>
                        <div className="design-pts">
                            <div className="sub-intruct">Lựa chọn loại mô phỏng</div>
                            <div className="list-pts">
                                {listPts ? (
                                    listPts.map((x, index) => {
                                        let isActive = x.fileUrl == partnerDesign.photoshopUrl;
                                        return (
                                            <div
                                                className={`pts-item ${isActive ? "active" : ""}`}
                                                key={index}
                                                onClick={(e) => {
                                                    setPartnerDesign({ ...partnerDesign, photoshopUrl: x.fileUrl });
                                                }}
                                            >
                                                <img src={x.thumbnail} alt="" />

                                                {isActive && (
                                                    <React.Fragment>
                                                        <div className="check-icon">
                                                            <img src={CheckedOrange} alt="" />
                                                        </div>
                                                        <div className="orange-background"></div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div>Hiện không có dữ liệu</div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                <section className="design-right">
                    <section className="card-design">
                        <div className="design-name">
                            <div className="form-group">
                                <div className="form-label">
                                    <label htmlFor="">Tên thiết kế</label>
                                    <div className="float-count">{partnerDesign.title ? partnerDesign.title.length : 0}/120 kí tự</div>
                                </div>
                                <input
                                    className="design-title"
                                    type="text"
                                    placeholder="Nhập tên thiết kế"
                                    value={partnerDesign.title}
                                    onChange={(e) => {
                                        setPartnerDesign({ ...partnerDesign, title: e.target.value });
                                    }}
                                />
                            </div>
                        </div>

                        <div className="design-description">
                            <div className="form-group">
                                <div className="form-label">
                                    <label htmlFor="">Mô tả thiết kế</label>
                                    <div className="float-count">{partnerDesign.description ? partnerDesign.description.length : 0}/3000 kí tự</div>
                                </div>
                                <textarea
                                    className={`description ${partnerDesign.description && partnerDesign.description.length > 3000 ? "is-alert" : ""}`}
                                    type="text"
                                    placeholder="Nhập tên thiết kế"
                                    value={partnerDesign.description}
                                    onChange={(e) => {
                                        setPartnerDesign({ ...partnerDesign, description: e.target.value });
                                    }}
                                    rows={8}
                                />
                            </div>
                        </div>
                        <div className="design-tag">
                            <section className="seo">
                                <div className="tag">
                                    <div className="tag-title">
                                        Thêm tag
                                        <span>(Mỗi tag kết thúc bằng phím Enter, tối đa 10 tag)</span>
                                    </div>
                                    <div className="tag-input">
                                        <div className="tag-area">
                                            <TagsInput
                                                addKeys={[13]}
                                                addOnPaste
                                                maxTags={10}
                                                inputProps={{ placeholder: "" }}
                                                value={partnerDesign.tagsConnection || []}
                                                onChange={(tags) => {
                                                    setPartnerDesign({ ...partnerDesign, tagsConnection: tags });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="tag-suggest">
                                    <div className="title">
                                        Gợi ý xu hướng<span>(Nhấp vào tag để chọn)</span>
                                    </div>
                                    <div className="suggest">
                                        {tagTrending &&
                                            tagTrending.length > 0 &&
                                            tagTrending.map((item, idx) => {
                                                return (
                                                    <span
                                                        className="suggest-item cursor-pointer"
                                                        key={idx}
                                                        onClick={(e) => {
                                                            let pd = { ...partnerDesign };
                                                            pd.tagsConnection = pd.tagsConnection || [];
                                                            if (pd.tagsConnection.indexOf(item) === -1) pd.tagsConnection.push(item);
                                                            setPartnerDesign(pd);
                                                        }}
                                                    >
                                                        {item}
                                                    </span>
                                                );
                                            })}
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                </section>

                <section className="card-product">
                    <h6>Thông tin giá bán</h6>
                    <div className="card-product-action">
                        <div className="product-action-left">
                            <h6>Thiết lập hàng loạt</h6>
                            <div className="action-form">
                                <label htmlFor="">Lợi nhuận gộp</label>
                                <div className="input-group-revenue">
                                    <input
                                        className="revenue"
                                        type={"number"}
                                        placeholder="Số tiền"
                                        value={revenue.total}
                                        onChange={(e) => {
                                            setRevenue({ ...revenue, total: +e.target.value });
                                        }}
                                    />
                                    <span>Hoặc</span>
                                    <input
                                        className="revenue-percentage"
                                        type={"number"}
                                        placeholder="Lợi nhuận"
                                        value={revenue.percentage}
                                        onChange={(e) => {
                                            setRevenue({ ...revenue, percentage: +e.target.value });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="product-action-right">
                            <div className="action-lst">
                                <button
                                    className="btn"
                                    onClick={(e) => {
                                        let pd = { ...partnerDesign };
                                        let listCost = pd.partnerCosts;
                                        for (var p of listCost) {
                                            p.sellPrice = 0;
                                            p.vatCost = p.sellPrice - p.sellPrice / (1 + p.vat / 100);
                                            p.grossProfit = Math.ceil((p.sellPrice - p.vatCost - p.total) * 100) / 100;
                                            p.grossProfitPercentage = Math.floor((p.grossProfit / p.total) * 100);
                                            p.isActive = false;
                                        }
                                        setPartnerDesign(pd);
                                    }}
                                >
                                    Xóa hàng loạt
                                </button>
                                <button
                                    className="btn"
                                    onClick={(e) => {
                                        if (!revenue || (!revenue.total && !revenue.percentage)) {
                                            Notify(NOTIFY.ERROR, "Thất bại", "Vui lòng nhập giá trị lợi nhuận");
                                            return;
                                        }

                                        if (revenue.total > 0) {
                                            let pd = { ...partnerDesign };
                                            let listCost = pd.partnerCosts;
                                            for (var p of listCost) {
                                                p.grossProfit = +revenue.total;
                                                p.grossProfitPercentage = Math.floor((p.grossProfit / p.total) * 100);
                                                //tính lại giá bán và vat
                                                p.sellPrice = Math.ceil((p.grossProfit + p.total) * (1 + p.vat / 100));
                                                p.vatCost = p.sellPrice - p.sellPrice / (1 + p.vat / 100);
                                            }
                                            setPartnerDesign(pd);
                                        } else if (revenue.percentage > 0) {
                                            let pd = { ...partnerDesign };
                                            let listCost = pd.partnerCosts;
                                            for (var p of listCost) {
                                                p.grossProfitPercentage = revenue.percentage;
                                                p.grossProfit = Math.ceil((p.total * p.grossProfitPercentage) / 100);
                                                p.sellPrice = Math.ceil((p.grossProfit + p.total) * (1 + p.vat / 100));
                                                p.vatCost = p.sellPrice - p.sellPrice / (1 + p.vat / 100);
                                            }
                                            setPartnerDesign(pd);
                                        }
                                    }}
                                >
                                    Cập nhật hàng loạt
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="product-table">
                        <table className="table table-boreder">
                            <thead>
                                <tr>
                                    <th>Dòng áo</th>
                                    <th width="20%">Hình ảnh</th>
                                    <th>Giá phôi</th>
                                    <th>Chi phí in</th>
                                    <th>Đóng gói</th>
                                    <th>Phí ship trung bình</th>
                                    <th>Tổng chi phí</th>
                                    <th>Giá bán</th>
                                    <th>Thuế VAT</th>
                                    <th>Lợi nhuận gộp - % Lợi nhuận/Chi phí</th>
                                    <th>Mặc định</th>
                                    <th>Hiển thị</th>
                                </tr>
                            </thead>
                            <tbody>
                                {partnerDesign.partnerCosts &&
                                    partnerDesign.partnerCosts.map((item, idx) => {
                                        const alert = item.sellPrice < item.total;
                                        let lstImage = item.partnerDesignProductImages || [];
                                        return (
                                            <tr key={idx} id={idx} className={`${item.isDefault ? "default-row" : ""}`}>
                                                <td className="center">{item.productName}</td>
                                                <td className="center">
                                                    <div className="list-image">
                                                        <DragAndDropIndex
                                                            data={lstImage}
                                                            renderRow={(ele, i) => {
                                                                let crop = ele.productImageUrl ? ele.productImageUrl.replace(".jpg", "_crop.webp") : "";
                                                                if (!crop) return "";
                                                                return (
                                                                    <div
                                                                        className="image-item"
                                                                        key={i}
                                                                        onMouseEnter={(e) => {
                                                                            let pd = { ...partnerDesign };
                                                                            let pc = pd.partnerCosts;
                                                                            let p = pc[idx];
                                                                            p.partnerDesignProductImages[i].isHover = true;
                                                                            setPartnerDesign(pd);
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            let pd = { ...partnerDesign };
                                                                            let pc = pd.partnerCosts;
                                                                            let p = pc[idx];
                                                                            p.partnerDesignProductImages[i].isHover = false;
                                                                            setPartnerDesign(pd);
                                                                        }}
                                                                        style={{
                                                                            opacity: ele.isDisabled ? 0.5 : 1,
                                                                        }}
                                                                    >
                                                                        <img src={crop} alt="" />

                                                                        {ele.isHover && (
                                                                            <div className="background-action">
                                                                                <div className="lst-action">
                                                                                    <div
                                                                                        className="eye-off"
                                                                                        onClick={(e) => {
                                                                                            handleDisabled(ele.id, !ele.isDisabled, idx);
                                                                                        }}
                                                                                    >
                                                                                        <img src={EyeOff} alt="" />
                                                                                    </div>
                                                                                    <div
                                                                                        className="remove-item"
                                                                                        onClick={(e) => {
                                                                                            handleDelete(ele.id, idx);
                                                                                        }}
                                                                                    >
                                                                                        <img src={Delete} alt="" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {item.isDefault && i == 0 && (
                                                                            <div className="background-cover">
                                                                                <span>Ảnh bìa</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }}
                                                            updateIndexFolder={(newLstImage) => {
                                                                let pd = { ...partnerDesign };
                                                                let pc = pd.partnerCosts;
                                                                let p = pc[idx];
                                                                p.partnerDesignProductImages = newLstImage;
                                                                setPartnerDesign(pd);
                                                            }}
                                                        />
                                                        {lstImage.length <= 6 && (
                                                            <div
                                                                className="add-image-button cursor-pointer"
                                                                onClick={(e) => {
                                                                    document.getElementById(`upload-image-${idx}`).click();
                                                                }}
                                                            >
                                                                <i className="fa fa-plus"></i>
                                                                <span>Thêm hình</span>
                                                            </div>
                                                        )}

                                                        <div className="input-file">
                                                            <input
                                                                id={`upload-image-${idx}`}
                                                                type="file"
                                                                className="d-none"
                                                                onChange={(e) => {
                                                                    handleImageChange(e).then((res) => {
                                                                        if (res) {
                                                                            let pd = { ...partnerDesign };
                                                                            let pc = pd.partnerCosts;
                                                                            let p = pc[idx];
                                                                            p.partnerDesignProductImages.push({
                                                                                productImageUrl: res,
                                                                                id: Common.randomId(0, 99999),
                                                                                imageType: IMAGE_TYPE.ProductCustomize,
                                                                            });
                                                                            setPartnerDesign(pd);
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="center">{Common.formatCurrency(item.partnerCost)}</td>
                                                <td className="center">{Common.formatCurrency(item.printCost)}</td>
                                                <td className="center">{Common.formatCurrency(item.packageCost)}</td>
                                                <td className="center">{Common.formatCurrency(item.shippingFee)}</td>
                                                <td className="center">{Common.formatCurrency(item.total)}</td>
                                                <td className="center">
                                                    <div className={`input-price ${alert ? "is-alert" : ""}`}>
                                                        <input
                                                            type="number"
                                                            placeholder="Giá tiền"
                                                            value={item.sellPrice}
                                                            onChange={(e) => {
                                                                let pd = { ...partnerDesign };
                                                                let pc = pd.partnerCosts;
                                                                let p = pc[idx];
                                                                p.sellPrice = e.target.value || 0;
                                                                p.vatCost = p.sellPrice - p.sellPrice / (1 + p.vat / 100);
                                                                p.grossProfit = Math.ceil((p.sellPrice - p.vatCost - p.total) * 100) / 100;
                                                                p.grossProfitPercentage = Math.floor((p.grossProfit / p.total) * 100);
                                                                setPartnerDesign(pd);
                                                            }}
                                                        />
                                                        <span className="suf-fix">đ</span>
                                                    </div>
                                                    {alert && <div className="not-valid">Giá bị thấp hơn tổng chi phí</div>}
                                                </td>
                                                <td className="center">{Common.formatCurrency(item.vatCost)}</td>
                                                <td className="center">
                                                    <div className="input-group-revenue">
                                                        <input
                                                            className="revenue"
                                                            type={item.grossProfit == 0 ? "text" : "number"}
                                                            placeholder="Số tiền"
                                                            value={item.grossProfit || null}
                                                            onChange={(e) => {
                                                                let pd = { ...partnerDesign };
                                                                let pc = pd.partnerCosts;
                                                                let p = pc[idx];
                                                                p.grossProfit = +e.target.value;
                                                                p.grossProfitPercentage = Math.floor((p.grossProfit / p.total) * 100);
                                                                //tính lại giá bán và vat
                                                                p.sellPrice = Math.ceil((p.grossProfit + p.total) * (1 + p.vat / 100));
                                                                p.vatCost = p.sellPrice - p.sellPrice / (1 + p.vat / 100);
                                                                setPartnerDesign(pd);
                                                            }}
                                                        />
                                                        <span>Hoặc</span>
                                                        <input
                                                            className="revenue-percentage"
                                                            type={item.grossProfitPercentage == 0 ? "text" : "number"}
                                                            placeholder="Lợi nhuận"
                                                            value={item.grossProfitPercentage || null}
                                                            onChange={(e) => {
                                                                let pd = { ...partnerDesign };
                                                                let pc = pd.partnerCosts;
                                                                let p = pc[idx];
                                                                p.grossProfitPercentage = +e.target.value;
                                                                p.grossProfit = Math.ceil((p.total * p.grossProfitPercentage) / 100);
                                                                p.sellPrice = Math.ceil((p.grossProfit + p.total) * (1 + p.vat / 100));
                                                                p.vatCost = p.sellPrice - p.sellPrice / (1 + p.vat / 100);
                                                                setPartnerDesign(pd);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="center">
                                                    <input
                                                        type="radio"
                                                        checked={item.isDefault}
                                                        onChange={(e) => {
                                                            let pd = { ...partnerDesign };
                                                            let pc = pd.partnerCosts;
                                                            for (var element of pc) {
                                                                element.isDefault = false;
                                                            }
                                                            let p = pc[idx];
                                                            p.isDefault = true;
                                                            setPartnerDesign(pd);
                                                        }}
                                                    />
                                                </td>
                                                <td className="center">
                                                    <SwichToogle
                                                        name={"switch_" + idx}
                                                        value={item.isActive}
                                                        onCheckChanged={(name, value) => {
                                                            let pd = { ...partnerDesign };
                                                            let pc = pd.partnerCosts;
                                                            let p = pc[idx];
                                                            p.isActive = value;
                                                            setPartnerDesign(pd);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </section>
                <section className="bottom-btn">
                    <div className="list-btn">
                        <button
                            className="btn btn-cancel"
                            onClick={(e) => {
                                ConfirmDialog("Xác nhận hủy bỏ?", "Bạn có chắc chắn muốn hủy bỏ thay đổi không?", () => {
                                    return new Promise((resolve, reject) => {
                                        history.push("/manage-customize");
                                        resolve({ title: "Thành công", msg: "Hủy bỏ thành công." });
                                    });
                                });
                            }}
                        >
                            Hủy
                        </button>
                        <button
                            className="btn btn-confirm"
                            onClick={(e) => {
                                savePartnerDesign(partnerDesign);
                            }}
                        >
                            Hoàn thành
                        </button>
                    </div>
                </section>
            </Wrapper>
        </React.Fragment>
    );
}

export default EditCustomize;

const Wrapper = styled.div`
    width: 80vw;
    display: flex;
    flex-wrap: wrap;

    .info-section {
        margin-left: 24px;
    }

    .background-cover {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 50%;
        border-radius: 0px 0px 8px 8px;
        background: rgba(255, 144, 39, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .background-cover span {
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .default-row {
        background: #fff5ec;
    }

    .image-item {
        position: relative;
    }

    .background-action {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.6);
    }

    .lst-action {
        display: flex;
    }

    .lst-action > div {
        margin: 0 4px;
    }

    .list-image tbody {
        display: flex;
        align-items: center;
    }

    .input-group-revenue span {
        flex-shrink: 0;
    }

    .add-image-button {
        width: 74px;
        height: 74px;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        margin: 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .image-item {
        margin: 6px;
    }

    .add-image-button span {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .image-item {
        width: 74px;
        height: 74px;
        border-radius: 8px;
        overflow: hidden;
    }

    .image-item img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain;
    }

    section.card-product {
        width: 100%;
    }

    section.bottom-btn {
        width: 100%;
    }

    section.design-left {
        width: calc(50% - 20px);
        margin-right: 20px;
    }

    section.design-right {
        width: 50%;
    }

    .design-left-top {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 18px 24px;
    }

    .design-left-top h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .design-left-bottom {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        margin-top: 20px;
        padding: 18px 24px;
    }

    section.seo {
        flex-direction: column;
    }

    .tag-suggest {
        margin: 10px 0;
    }

    .suggest {
        margin-top: 12px;
    }

    span.react-tagsinput-tag {
        border-radius: 30px;
        background: #ff9027;
        border: none;
        padding: 4px 10px;
    }

    .pts-item {
        overflow: hidden;
    }

    .alert {
        outline: 1.5px solid red !important;
    }

    section.bottom-btn {
        background: #fff;
    }

    section.bottom-btn {
        display: flex;
    }

    .list-btn {
        margin-left: auto;
        display: flex;
    }

    button.btn.btn-cancel {
        border-radius: 40px;
        background: #f3f3f3;
        margin: 10px;
        padding: 13px 32px;
        color: #303030;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    button.btn.btn-confirm {
        border-radius: 40px;
        background: #ff9027;
        margin: 10px;
        padding: 13px 32px;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    .input-price {
        width: 100%;
    }

    .input-price input[type="number"] {
        flex: 1;
    }
    input.revenue {
        padding: 0px 10px;
    }

    input.revenue-percentage {
        padding: 0 10px;
    }
    .input-price {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 10px 8px;
    }

    .input-price input[type="number"] {
        border: none;
    }

    .not-valid {
        color: #d70000;
        text-align: center;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 6px;
    }

    .is-alert {
        border: 1px solid #d70000;
    }

    .pts-item {
        position: relative !important;
    }

    .check-icon {
        position: absolute;
        top: 5px;
        left: 5px;
    }

    .orange-background {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        opacity: 0.5;
        background: linear-gradient(0deg, rgba(255, 144, 39, 0.3) 0%, rgba(255, 144, 39, 0.3) 100%), url(<path-to-image>) lightgray 50% / cover no-repeat;
    }
    tr td {
        border: 1px solid #e5e5e5;
    }
    tr td {
        color: #303030;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        vertical-align: middle;
    }

    section.card-product {
        border-radius: 12px;
        background: rgb(255, 255, 255);
        padding: 24px;
        margin: 24px 0;
    }

    section.card-product h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .card-product-action {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        padding: 24px 12px;
        margin: 12px 0;
    }

    .product-action-left {
        display: flex;
        align-items: center;
    }

    .action-form {
        display: flex;
        align-items: center;
        margin-left: 24px;
    }

    .product-action-right {
        margin-left: auto;
    }

    .action-form label {
        color: #303030;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 12px 0 0;
    }

    .input-group-revenue {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .input-group-revenue span {
        border: 1px solid #d9d9d9;
        background: #444;
        color: #fff;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 9px 13px;
        /* height: 34px; */
    }

    input.revenue {
        border-radius: 8px 0px 0px 8px;
        border: 1px solid #d9d9d9;
        background: #fff;
        align-self: stretch;
    }

    input.revenue-percentage {
        align-self: stretch;
        border-radius: 0px 8px 8px 0px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .action-lst button.btn {
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        background: #444;
        color: #fff !important;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 10px;
        padding: 9px 10px;
    }

    .table thead {
        border-radius: 8px 8px 0px 0px !important;
        border: 1px solid #e5e5e5;
        background: #f8f8f8;
    }

    table.table.table-boreder {
        border-radius: 8px;
        overflow: hidden;
    }

    tr th {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 10px !important;
    }

    /* Thông tin thiết kế */
    section.card-design {
        border-radius: 12px;
        background: #fff;
        padding: 24px;
    }

    section.card-design h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px !important;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .list-image {
        display: flex;
    }

    .list-image img {
        width: 180px;
        height: 180px;
        border-radius: 10px;
    }

    .design-info {
        display: flex;
        margin: 12px 0;
    }

    .info-section {
        display: flex;
        flex-direction: column;
    }

    .info-line {
        display: flex;
        align-items: baseline;
    }

    .info-line label {
        color: #a5a5a5;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .info-line span {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    .edit-button {
        margin-top: auto;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 13px 18px;
    }

    .form-label {
        display: flex;
        align-items: baseline;
    }

    .form-label label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .float-count {
        margin-left: auto;
        color: #a5a5a5;
        text-align: right;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    input.design-title {
        width: 100%;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 10px;
        margin: 6px 0;
    }

    .design-side {
        display: flex;
        align-items: baseline;
        margin: 12px 0;
    }

    .design-side label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .radio-box {
        display: flex;
        align-items: center;
        margin: 0 12px;
    }

    .radio-box label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 0;
        margin-left: 6px;
    }

    .design-name {
        margin: 12px 0;
    }

    .design-pts {
        margin: 12px 0;
    }

    .sub-intruct {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .list-pts {
        display: flex;
        flex-wrap: wrap;
    }

    .pts-item {
        width: 90px;
        height: 90px;
        flex-shrink: 0;
        margin: 10px;
    }

    .pts-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .pts-item.active {
        border-radius: 8px;
        border: 1px solid #ff9027;
        background: linear-gradient(0deg, rgba(255, 144, 39, 0.3) 0%, rgba(255, 144, 39, 0.3) 100%), url(<path-to-image>) lightgray 50% / cover no-repeat;
    }

    .design-description {
        margin: 12px 0;
    }

    textarea.description {
        width: 100%;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 10px;
    }

    section.seo {
        display: flex;
    }

    .tag {
    }

    .tag-suggest {
        flex: 1;
    }

    section.design-left {
        width: calc(50% - 20px);
        margin-right: 20px;
    }

    section.design-right {
        width: 50%;
    }

    .design-left-top {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 18px 24px;
    }

    .design-left-top h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .design-left-bottom {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        margin-top: 20px;
        padding: 18px 24px;
    }

    section.seo {
        flex-direction: column;
    }

    .tag-suggest {
        margin: 10px 0;
    }

    .suggest {
        margin-top: 12px;
    }

    span.react-tagsinput-tag {
        border-radius: 30px;
        background: var(--Cam-Thng-hiu, #ff9027);
        border: none;
        padding: 4px 10px;
    }

    .suggest {
        display: flex;
        flex-wrap: wrap;
    }

    .tag-title {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 12px 0;
    }

    .tag-title span {
        color: #707070;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    .tag-input {
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .title {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .title span {
        color: #707070;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    span.suggest-item {
        border-radius: 30px;
        border: 1px solid #ff9027;
        padding: 5px 12px;
        margin: 6px;
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;
